import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import * as moment from 'moment-timezone';

import { SessionService } from '../session';

const DEFAULT_FORMAT = 'DD/MM/YYYY à HH:mm';
const SHORT_FORMAT = 'DD/MM/YYYY';

@Pipe({ name: 'tzdate', pure: false })
export class TzDatePipe implements PipeTransform, OnDestroy {

  private timezone: string
  private latestValue: any;
  private latestResturnValue: string;
  private subscription: Subscription;

  constructor(private sessionService: SessionService) { }

  transform(value: any, ...args: any[]) {
    if (value === null || value === undefined) {
      return '';
    }

    // No need to reformat
    if (this.latestValue === value) {
      return this.latestResturnValue;
    }

    // Get the current user
    if (!this.timezone) {
      this.subscription = this.sessionService.currentUser.subscribe((user) => {
        this.timezone = user.timezone;
      });
    }
    // Format using the latest timezone
    else {

      // Get the format
      let format = args[0];
      
      if(format === 'short') {
        format = SHORT_FORMAT;
      }
      else if(!format) {
        format = DEFAULT_FORMAT;
      }

      // Format
      let epoch = parseInt(value, 10);
      let date = moment.tz(epoch, this.timezone);
      this.latestResturnValue = date.format(format);
      this.latestValue = value;

      return this.latestResturnValue;
    }

    // Return empty string if no date was formatted
    return '';
  }

  ngOnDestroy() {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
